export default {"src":"/_next/static/media/language-badge.fecaa1df.svg","height":122,"width":121,"blurWidth":0,"blurHeight":0};